import { render, staticRenderFns } from "./ConsolidationMeestTableMobile.vue?vue&type=template&id=6c5185f8&scoped=true"
import script from "./ConsolidationMeestTableMobile.vue?vue&type=script&lang=js"
export * from "./ConsolidationMeestTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5185f8",
  null
  
)

export default component.exports